import { makeAutoObservable } from 'mobx';
import * as noticeService from '@/services/notice';

export class Notice {
  notice = {};

  constructor() {
    makeAutoObservable(this);
  }

  getNotice(params) {
    return noticeService.getNotice(params);
  }

  saveContent(params) {
    return noticeService.saveContent(params);
  }
}

export const NOTICE = 'notice';
